module.exports = window.$bonelibs.AliWind_3;